import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import _ from 'lodash';
import {
  verifyForgotOtp,
  resendForgotOtp,
  resetPassword,
} from '../utils/paymentApi';
import { setAuthToken } from '../utils/guestStorage';
import { showError, showSuccess } from '../utils/snackbar';
import './Auth.css';

// Step 2–3: verify reset OTP, then set a new password
class ResetPassword extends Component {
  constructor(props) {
    super(props);
    const params = new URLSearchParams(window.location.search);
    this.state = {
      email: params.get('email') || '',
      otp: '',
      resetToken: '',
      newPassword: '',
      confirmPassword: '',
      step: 'otp',
      loading: false,
    };
  }

  handleChange = (field) => (event) => {
    this.setState({ [field]: event.target.value });
  };

  handleVerifyOtp = async (event) => {
    event.preventDefault();
    try {
      this.setState({ loading: true });
      const result = await verifyForgotOtp({
        email: this.state.email,
        otp: this.state.otp,
      });
      this.setState({
        resetToken: _.get(result, 'resetToken', ''),
        step: 'password',
      });
      showSuccess('Code verified. Choose a new password.');
    } catch (e) {
      showError(_.get(e, 'message', 'Verification failed'));
    } finally {
      this.setState({ loading: false });
    }
  };

  handleResend = async () => {
    try {
      this.setState({ loading: true });
      await resendForgotOtp(this.state.email);
      showSuccess('A new code was sent if the account exists.');
    } catch (e) {
      showError(_.get(e, 'message', 'Could not resend code'));
    } finally {
      this.setState({ loading: false });
    }
  };

  handleResetPassword = async (event) => {
    event.preventDefault();
    const { newPassword, confirmPassword, resetToken } = this.state;
    if (String(newPassword).length < 8) {
      showError('New password must be at least 8 characters');
      return;
    }
    if (newPassword !== confirmPassword) {
      showError('Passwords do not match');
      return;
    }
    try {
      this.setState({ loading: true });
      const result = await resetPassword({
        resetToken,
        newPassword,
      });
      setAuthToken(_.get(result, 'token', ''));
      showSuccess('Password updated. You are signed in.');
      window.location.href = '/profile';
    } catch (e) {
      showError(_.get(e, 'message', 'Could not reset password'));
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const {
      email,
      otp,
      newPassword,
      confirmPassword,
      step,
      loading,
    } = this.state;

    return (
      <div className="auth-page">
        <div className="auth-card">
          {step === 'otp' ? (
            <div>
              <h1 className="auth-title">Enter reset code</h1>
              <p className="auth-sub">Enter the 6-digit code we sent to your email.</p>
              <form onSubmit={this.handleVerifyOtp}>
                <label htmlFor="rp-email">Email</label>
                <input
                  id="rp-email"
                  type="email"
                  value={email}
                  onChange={this.handleChange('email')}
                  required
                />
                <label htmlFor="rp-otp">OTP code</label>
                <input
                  id="rp-otp"
                  value={otp}
                  onChange={this.handleChange('otp')}
                  required
                  maxLength={6}
                />
                <button type="submit" className="auth-cta" disabled={loading}>
                  {loading ? 'Verifying…' : 'Verify code'}
                </button>
              </form>
              <button
                type="button"
                className="auth-link-btn"
                onClick={this.handleResend}
                disabled={loading}
              >
                Resend code
              </button>
              <p className="auth-footer">
                <Link to="/forgot-password">Use a different email</Link>
              </p>
            </div>
          ) : (
            <div>
              <h1 className="auth-title">Set new password</h1>
              <p className="auth-sub">Choose a new password (at least 8 characters).</p>
              <form onSubmit={this.handleResetPassword}>
                <label htmlFor="rp-new">New password</label>
                <input
                  id="rp-new"
                  type="password"
                  value={newPassword}
                  onChange={this.handleChange('newPassword')}
                  required
                  minLength={8}
                />
                <label htmlFor="rp-confirm">Confirm password</label>
                <input
                  id="rp-confirm"
                  type="password"
                  value={confirmPassword}
                  onChange={this.handleChange('confirmPassword')}
                  required
                  minLength={8}
                />
                <button type="submit" className="auth-cta" disabled={loading}>
                  {loading ? 'Saving…' : 'Update password'}
                </button>
              </form>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default ResetPassword;
